import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { HelpInfo } from "./HelpInfo";

interface HelpInfoContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: HelpInfoContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;
    const visible = Boolean(viewModelSelect.controlModel(state, bindingPath).value);
    return { visible: visible };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: HelpInfoContainerProps) => {
    const { bindingPath } = ownProps;
    return {
        setValue: (value: boolean) => dispatch(setToModel(bindingPath, "value", value)),
    };
};

export const HelpInfoContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(HelpInfo))
);
